export const getUserLabel = (
  profile?: Partial<{ firstName: string; lastName: string; email: string }>
) => {
  if (!profile) {
    return "Unknown";
  }
  if (profile.lastName || profile.firstName) {
    return [profile.firstName, profile.lastName].filter((v) => !!v).join(" ");
  }
  if (profile.email) {
    return profile.email;
  }
  return "Unknown";
};
